import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-254c5120"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "modal-no-show-booking" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "font-medium" }, " Please select a start and end date for the dashboard statistics ", -1));
const _hoisted_3 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" };
const _hoisted_4 = { class: "buttons" };
const _hoisted_5 = /*#__PURE__*/ _createTextVNode("Close");
const _hoisted_6 = /*#__PURE__*/ _createTextVNode("Set Dates");
import Button from "@/components/Button.vue";
import Modal from "@/components/Modal.vue";
import DateInput from "@/components/DateInput.vue";
import { reactive, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        show: { type: Boolean },
        starts: null,
        ends: null
    },
    emits: ["update:show", "update:starts", "update:ends", "confirm"],
    setup(__props, { emit }) {
        const props = __props;
        const form = reactive({
            starts: props.starts,
            ends: props.ends
        });
        const show = ref(props.show);
        const hide = emit("update:show", false);
        watch(() => props.show, (value) => show.value = value);
        watch(() => form.starts, (d) => emit("update:starts", d));
        watch(() => form.ends, (d) => emit("update:ends", d));
        function submit() {
            emit('confirm');
            emit("update:show", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, _mergeProps({ "allow-close": true }, _ctx.$attrs, {
                show: show.value,
                "onUpdate:show": _cache[2] || (_cache[2] = ($event) => ((show).value = $event))
            }), {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _hoisted_2,
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(DateInput, {
                                label: "Start Date",
                                modelValue: _unref(form).starts,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).starts) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(DateInput, {
                                label: "End Date",
                                modelValue: _unref(form).ends,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).ends) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(Button, { variant: "grey" }, {
                                default: _withCtx(() => [
                                    _hoisted_5
                                ]),
                                _: 1
                            }),
                            _createVNode(Button, {
                                onClickPassive: submit,
                                variant: "light"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_6
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _: 1
            }, 16, ["show"]));
        };
    }
});
